import React from 'react';
import { Box } from '@mui/material';
import FieldRow from './FieldRow';
import LocalizedField from './LocalizedField';
import SectionBlock from './SectionBlock';

export default function AdvertiserDetailPanel({ data, diffKeys = new Set(), side }) {
  if (!data) return null;

  return (
    <Box>
      <SectionBlock title="Identity" />
      <LocalizedField
        label="Name"
        fieldKey="localizedName"
        data={data.localizedName}
        diffKeys={diffKeys}
        side={side}
      />
      <FieldRow
        label="Industry"
        value={data.industry}
        isChanged={diffKeys.has('industry')}
        side={side}
      />
      {/* Active field — hidden for now
      <FieldRow
        label="Active"
        value={data.isActive == null ? null : (data.isActive ? 'Yes' : 'No')}
        isChanged={diffKeys.has('isActive')}
        side={side}
      />
      */}
    </Box>
  );
}
